export const calendarGoogleMembers = {
    GET_CALENDAR_GOOGLE_MEMBERS: "GET_CALENDAR_GOOGLE_MEMBERS",
    GET_CALENDAR_GOOGLE_MEMBERS_SUCCESS : "GET_CALENDAR_GOOGLE_MEMBERS_SUCCESS",
    GET_CALENDAR_GOOGLE_MEMBERS_NULL : "GET_CALENDAR_GOOGLE_MEMBERS_NULL",
    GET_CALENDAR_GOOGLE_MEMBERS_ERROR : "GET_CALENDAR_GOOGLE_MEMBERS_ERROR",
}